import {
    ResultObj,
    allFetch,
} from "../Domain";
import { DDMenuItem } from "../types";



/** 
 * @description 新建保險(參數) 
 * @param {string} insurance_type 保險種類*
 * @param {string} insurance_name 保險名稱*
 * @param {string} company_id 保險公司流水號
 * @param {string} note 備註
*/
export interface InsuranceCreateParams {
    insurance_type: string,
    insurance_name: string,
    company_id: string,
    note: string,
}

/** @description 新建保險(回傳) */
export type InsuranceCreateResItem = {
}
/**
 * @description 新建保險
 */
export const InsuranceCreate = async (
    obj: InsuranceCreateParams = {
        insurance_type: '',
        insurance_name: '',
        company_id: '',
        note: ''
    }): Promise<ResultObj<InsuranceCreateResItem[]>> => {
    return await allFetch("Insurance/InsuranceCreate", obj);
};



/** 
 * @description 修改保險(參數) 
 * @param {string} insurance_id 保險流水號*
 * @param {string} insurance_type 保險種類*
 * @param {string} insurance_name 保險名稱*
 * @param {string} company_id 保險公司流水號
 * @param {string} note 備註
 * @param {string} visible 是否可見*
*/
export interface InsuranceUpdateParams {
    insurance_id: string,
    insurance_type: string,
    insurance_name: string,
    company_id: string,
    note: string,
    visible: "Y" | "N",
}

/** @description 修改保險(回傳) */
export type InsuranceUpdateResItem = {
}
/**
 * @description 修改保險
 */
export const InsuranceUpdate = async (
    obj: InsuranceUpdateParams = {
        insurance_id: '',
        insurance_type: '',
        insurance_name: '',
        company_id: '',
        note: '',
        visible: "Y"
    }): Promise<ResultObj<InsuranceUpdateResItem[]>> => {
    return await allFetch("Insurance/InsuranceUpdate", obj);
};


/** 
 * @description 查詢保險(參數) 
 * @param {string} insurance_type 保險種類
 * @param {string} insurance_name 保險名稱
 * @param {string} company_id 保險公司流水號
 * @param {string} visible 是否可見
 * @param {number} page 頁碼
 * @param {number} num_per_page 一頁幾筆
*/
export interface InsuranceSearchParams {
    insurance_type: string,
    insurance_name: string,
    company_id: string,
    visible: "Y" | "N",
    page: number,
    num_per_page: number
}

/** @description 查詢保險(回傳) */
export type InsuranceSearchResItem = {
    insurance_id: string,
    insurance_type: string,
    insurance_type_name: string,
    insurance_name: string,
    company_id: string,
    visible: "Y" | "N",
    note: string,
}
/**
 * @description 查詢保險
 */
export const InsuranceSearch = async (
    obj: InsuranceSearchParams = {
        insurance_type: '',
        insurance_name: '',
        company_id: '',
        visible: 'Y',
        page: 1,
        num_per_page: 10
    }): Promise<ResultObj<InsuranceSearchResItem[]>> => {
    return await allFetch("Insurance/InsuranceSearch", obj);
};


/** 
 * @description 保險細項(參數) 
 * @param {string} insurance_id 保險流水號
*/
export interface InsuranceDetailParams {
    insurance_id: string,
}

/** @description 保險細項(回傳) */
export type InsuranceDetailResItem = {
    company_id: string;
    insurance_id: string;
    insurance_name: string;
    insurance_type: string;
    insurance_type_name: string;
    note: string;
    visible: "Y" | "N",
}
/**
 * @description 保險細項
 */
export const InsuranceDetail = async (
    obj: InsuranceDetailParams = {
        insurance_id: ''
    }): Promise<ResultObj<InsuranceDetailResItem[]>> => {
    return await allFetch("Insurance/InsuranceDetail", obj);
};


/** 
 * @description 刪除保險(參數) 
 * @param {string} insurance_id 保險流水號
*/
export interface InsuranceDeleteParams {
    insurance_id: string,
}
/**
 * @description 刪除保險
 */
export const InsuranceDelete = async (
    obj: InsuranceDeleteParams = {
        insurance_id: ''
    }): Promise<ResultObj> => {
    return await allFetch("Insurance/InsuranceDelete", obj);
};